<template>
  <section class="page-header">
    <div class="header-title">
      <img src="../assets/images/header-title.png" alt="">
    </div>
    <div class="header-ling">
      <div>
        <img src="../assets/images/header-left.svg" alt="">
        <span class="text">年累计销售额</span>
        <img src="../assets/images/header-right.svg" alt="">
      </div>
      <div class="value">
        <span class="number">
          <span v-for="(item, index) in value" :key="index">{{ item }}</span>
        </span>
        <span class="unit">元</span>
      </div>
      <div class="rate">
        同比增长率：<span class="rate-value">{{yearAllSalesVo.growthRate}}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'page-header',
  props: {
    yearAllSalesVo: Object
  },
  computed: {
    value () {
      let num = this.yearAllSalesVo.yearTotalSales.toString()
      console.log(num.split(''))
      return num.split('')
    }
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.page-header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .header-title{
    width: 90%;
    img{
      width: 100%;
    }
  }
  .header-ling{
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    >div{
      width: 50%;
      display: flex;
      justify-content: space-between;
      .text{
        font-size: 19px;
        font-weight: bold;
        line-height: 19px;
        color: #fff;
      }
    }
    .value{
      display: flex;
      justify-content: center;
      width: 55%;
      align-items: flex-end;
      color: #fff;
      .number{
        flex: 1;
        font-size: 60px;
        font-family: 'NumFont', sans-serif;
        display: flex;
        justify-content: space-between; /* 元素在容器内均匀分布 */
        font-weight: bold;
        width: 100%; /* 或者指定固定宽度 */
      }
      .unit{
        font-family: Microsoft YaHei;
        font-size: 21.93px;
        font-weight: 290;
        line-height: 21.93px;
      }
    }
    .rate{
      width: 55%;
      font-size: 18px;
      font-weight: normal;
      line-height: 18px;
      justify-content: flex-start;
      color: #fff;
      .rate-value{
        color: #7BF9FF
      }
    }
  }
  @media (max-width: 768px) {
    .header-ling{
      >div{
        justify-content: center;
        >img{
          display: none;
        }
      }
      .value{
        width: 80%;
        .number{
          font-size: 36px;
        }
        .unit{
          font-size: 18px;
        }
      }
    }
  }
}
</style>
